import { render, staticRenderFns } from "./AddressSuggestion.vue?vue&type=template&id=75d9466c&scoped=true"
import script from "./AddressSuggestion.vue?vue&type=script&lang=js"
export * from "./AddressSuggestion.vue?vue&type=script&lang=js"
import style0 from "./AddressSuggestion.vue?vue&type=style&index=0&id=75d9466c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d9466c",
  null
  
)

export default component.exports